/**
 * Recorrido de un pedido en tres pasos, para la linea de estado del modal
 * (ADM-09): creado, pagado y con su boleta o factura.
 *
 * No hay paso de despacho: el sitio no sabe cuando sale un pedido, y un paso
 * que nunca se completa dice que algo falta cuando no.
 */
import type { PedidoAdminDetalle } from '@bandu/compartido';

import { nombreDocumento } from './textos-pedido';

/** `actual` es el paso que se esta esperando; `fallido`, el que corto el recorrido. */
export type EstadoPaso = 'hecho' | 'actual' | 'fallido' | 'pendiente';

export interface PasoPedido {
  nombre: string;
  estado: EstadoPaso;
  /** Cuando paso, si paso. */
  fecha: string | null;
  /** Lo que se dice debajo cuando no hay fecha. */
  detalle: string;
}

function pasoPago(pedido: PedidoAdminDetalle): PasoPedido {
  const nombre = 'Pagado';
  if (pedido.estado === 'pagado') {
    return { nombre, estado: 'hecho', fecha: pedido.pagadoEn, detalle: 'Pagado' };
  }
  if (pedido.estado === 'rechazado') {
    return { nombre: 'Pago rechazado', estado: 'fallido', fecha: null, detalle: 'Webpay lo rechazo' };
  }
  if (pedido.estado === 'anulado') {
    return { nombre: 'Anulado', estado: 'fallido', fecha: null, detalle: 'El cliente no pago' };
  }
  return { nombre, estado: 'actual', fecha: null, detalle: 'Sin pagar' };
}

/** Un pedido pagado sin folio es trabajo pendiente (DOC-01): es el paso que se espera. */
function pasoDocumento(pedido: PedidoAdminDetalle, pago: PasoPedido): PasoPedido {
  const nombre = pedido.tipoDocumento === 'factura' ? 'Factura emitida' : 'Boleta emitida';
  if (pedido.folioDocumento !== null) {
    return { nombre, estado: 'hecho', fecha: pedido.fechaDocumento, detalle: 'Emitida' };
  }
  if (pago.estado === 'hecho') {
    return {
      nombre,
      estado: 'actual',
      fecha: null,
      detalle: `Falta subir la ${nombreDocumento(pedido).toLowerCase()}`,
    };
  }
  return { nombre, estado: 'pendiente', fecha: null, detalle: 'No corresponde' };
}

export function pasosPedido(pedido: PedidoAdminDetalle): PasoPedido[] {
  const pago = pasoPago(pedido);
  return [
    { nombre: 'Creado', estado: 'hecho', fecha: pedido.creadoEn, detalle: 'Creado' },
    pago,
    pasoDocumento(pedido, pago),
  ];
}
